import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { slideFromRight } from "./animations"
import bg from "../backgrounds/bg-containers-starmap.jpg"

const Container = styled.div`
  flex: auto;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${bg});
  background-size: cover;
  background-position: center;
  > * {
    animation: 0.3s ${slideFromRight} ease-out;
    max-width: 1900px;
    margin-left: auto;
    margin-right: auto;
  }
`
// CenteredPage centers its content in the middle of the screen,
// useful for small, attention-grabbing views like a login page.
const CenteredPage = ({ children }) => <Container>{children}</Container>

CenteredPage.propTypes = {
  children: PropTypes.any,
}

export default CenteredPage
